import { useEffect, useState } from 'react';

function useScrollProgress(ref: any, toleranceTop = 0, toleranceBottom = 0) {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const { scrollHeight, scrollTop, clientHeight } = document.documentElement;
      const articleSection = ref.current?.scrollHeight ?? 0;
      const height = scrollHeight - clientHeight;
      const articleBottomPadding = 100;
      const scrollPercentegeCalculation =
        ((scrollTop - toleranceTop) / (height - (scrollHeight - articleSection) + articleBottomPadding)) *
        toleranceBottom;
      const scrollPercentege = Math.max(0, scrollPercentegeCalculation);
      setPercentage(scrollPercentege);
    };
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [setPercentage, ref, toleranceTop, toleranceBottom]);

  return { percentage };
}

export default useScrollProgress;
